const NAME_BY_TYPE = {
    RelationshipNewProposalCustomer: 'relationshipNewProposalCustomer',
    RelationshipSigning: 'proposalNotSignedReminderCustomer',
    ProposalApprovalManualReminder: 'proposalApprovalManualReminder',
    RelationshipApprovedCustomer: 'relationshipApprovedCustomer',
    RelationshipUpdatedWithChanges: 'relationshipUpdatedWithChanges',
    AmendmentApprovalReminderCustomer: 'amendmentApprovalReminderCustomer',
    BankAccountNotVerifiedReminderCustomer: 'bankAccountNotVerifiedReminderCustomer',
    InvoiceIssued: 'invoiceIssuedAutoProcess',
    PaymentFailedCustomer: 'paymentFailedCustomer',
    InvoiceRefundedCustomer: 'invoiceRefundedCustomer',
    AdHocInvoiceIssued: 'adHocInvoiceIssued',
    AdHocInvoiceOverdueReminderCustomer: 'adHocInvoiceOverdueReminderCustomer'
};
const FALLBACK_NAME = 'relationshipApprovedCustomer';
export const notificationNameOf = (state)=>{
    var _NAME_BY_TYPE_state;
    return (_NAME_BY_TYPE_state = NAME_BY_TYPE[state]) !== null && _NAME_BY_TYPE_state !== void 0 ? _NAME_BY_TYPE_state : FALLBACK_NAME;
};
const CTA_BY_TYPE = {
    RelationshipNewProposalCustomer: 'Review and approve',
    RelationshipSigning: 'Review and approve',
    ProposalApprovalManualReminder: 'Review and approve',
    RelationshipApprovedCustomer: 'View agreement',
    RelationshipUpdatedWithChanges: 'Review changes',
    AmendmentApprovalReminderCustomer: 'Review changes',
    BankAccountNotVerifiedReminderCustomer: 'Verify bank account',
    RequestPaymentMethod: 'Add payment method',
    InvoiceIssued: 'View invoice',
    PaymentFailedCustomer: 'Update payment',
    InvoiceRefundedCustomer: 'View refund',
    AdHocInvoiceIssued: 'View invoice',
    AdHocInvoiceOverdueReminderCustomer: 'View invoice'
};
export const ctaTextFor = (state)=>{
    var _CTA_BY_TYPE_state;
    return (_CTA_BY_TYPE_state = CTA_BY_TYPE[state]) !== null && _CTA_BY_TYPE_state !== void 0 ? _CTA_BY_TYPE_state : '';
};
